<template>
	<div class="user_box" @click="onClickMypage">
		<div v-if="tokenStore.isLogin" class="user_content_box">
			<div class="user_content_img">
				<img v-if="authStore.getUserImg" :src="authStore.getUserImg" loading="lazy" alt="사용자 이미지" />
				<img v-else src="@/assets/img/character/master_01.png" loading="lazy" alt="사용자 이미지" />
			</div>
			<div class="user_content">
				<div class="user_content_title_box">
					<span class="user_content_title">
						<strong> {{ authStore.getMemberNickname }} </strong> 님
					</span>
					<div :class="['subscription_badge', { active: getCheckAuthData?.success }]">
						{{ getCheckAuthData?.success ? '프리미엄' : '일반' }}
					</div>
				</div>
				<span class="user_content_sub">{{ authStore.getMemberId }}</span>
			</div>
		</div>
		<div v-else class="login_box">로그인 하러가기</div>
		<img class="img_icon" src="@/assets/img/common/arrow_next.svg" alt="마이페이지 아이콘" loading="lazy" />
	</div>
</template>
<script setup lang="ts">
// core
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { useGetCheckAuthApi } from '@/api/auth';
// store
import { useAuthStore } from '@/stores/auth';
import { useTokenStore } from '@/stores/token';

const router = useRouter();
const tokenStore = useTokenStore();
const authStore = useAuthStore();

const emit = defineEmits(['close']);

const { data: getCheckAuthData } = useGetCheckAuthApi(
	computed(() => ({
		num: 'ALL',
		student: false,
		enable: tokenStore.isLogin,
	}))
);

// 마이페이지 및 로그인 이동
const onClickMypage = () => {
	emit('close');
	if (tokenStore.isLogin) {
		// router.push(window.innerWidth > 1280 ? '/my/history' : '/my');
		router.push('/my');
	} else {
		router.push('/auth/login');
	}
};
</script>

<style lang="scss" scoped>
.user_box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	background-color: var(--color-bg-mid);
	border-radius: 0.8rem;
	padding: 1.6rem;
	cursor: pointer;
	.user_content_box {
		display: flex;
		width: 100%;
		gap: 1rem;
		.user_content_img {
			width: 6rem;
			height: 6rem;
			border-radius: 6rem;
			background-color: #fff;
			overflow: hidden;
			img {
				object-fit: contain;
				width: 100%;
				height: 100%;
			}
		}
		.user_content {
			display: flex;
			flex-direction: column;
			align-items: start;
			justify-content: center;
			gap: 0.4rem;

			.user_content_title_box {
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;
				gap: 0.8rem;

				.user_content_title {
					font-size: var(--font-s-mid);
					font-weight: var(--font-w-semi-bold);
					line-height: normal;
					strong {
						color: #1690ff;
						font-size: var(--font-s-regular);
						line-height: 2.1rem;
					}
				}

				.subscription_badge {
					padding: 0.2rem 0.8rem;
					border-radius: 9999px;

					font-size: var(--font-s-small);
					font-weight: var(--font-w-light);
					line-height: 1.56rem;
					text-align: center;

					color: var(--color-primary-contrast);
					background-color: var(--color-base-disabled);

					&.active {
						background-color: var(--color-primary);
					}
				}
			}

			.user_content_sub {
				font-size: var(--font-s-mid);
				font-weight: var(--font-w-light);
				line-height: 1.9rem;
			}
		}
	}
	.login_box {
		padding: 0.4rem 0rem;
		font-size: var(--font-s-regular);
		font-weight: var(--font-w-semi-bold);
		line-height: 2.1rem;
	}
	.img_icon {
		width: 2.2rem;
		height: 2.2rem;
	}
}
</style>
